import { render, staticRenderFns } from "./BannerHomeModal.vue?vue&type=template&id=46ab6d60&scoped=true&"
import script from "./BannerHomeModal.vue?vue&type=script&lang=ts&"
export * from "./BannerHomeModal.vue?vue&type=script&lang=ts&"
import style0 from "./BannerHomeModal.vue?vue&type=style&index=0&id=46ab6d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab6d60",
  null
  
)

export default component.exports